import axios from 'axios';
import { getApiBaseUrl } from 'helpers/api';

const baseUrl = getApiBaseUrl();

const getOrganizations = (language: string) =>
  axios.get(`${baseUrl}/organizations?lang=${language}`);

export default {
  getOrganizations,
};
